<template>
    <div :class="error && form[paramName].$dirty ? 'custom-birthday--invalid' : 'custom-birthday--valid'"> 
      <label class="custom-label" :for="id + '_' + o" :class="[brandClass(),{'_profileStyle': profileStyle}]">
          {{ profileStyle ? $toUpperCase(label) : label }}
      </label>
      <div style="position: relative; display: flex;" class="custom-birthday-field" :class="brandClass()">
        <input
          class="custom-date-input"
          :class="[brandClass(), {'disabled':disabled}, {'_profileStyle':profileStyle}, getInputClass(index), o]"
          :placeholder="getPlaceholder(o)"
          :id="id + '_' + o" 
          :disabled="disabled"
          :readonly="readonly"
          :value="getInputValue(o)"
          :maxLength = "o === 'Y' ? '4': '2'"
          inputmode="numeric"
          @input="onInput" 
          @change="onChange" 
          @keydown="onKeydown" 
          @keyup="onKeyup"
          @blur="onBlur"
          v-for="(o, index) in order" :key="`${o}-${index}`" 
        />
    </div>
    <div class="custom-error" :class="brandClass()" v-if="error && form[paramName].$dirty" aria-live="polite" role="alert" :aria-labelledby="id + '_' + o">{{error.message}}</div>
  </div>
</template>

<script>

// import oneMoment from "../../../gcdm-one-library/gcdm-one-moment/src/bootstrap";

export default {
  inject:['brandClass', '$toUpperCase'],
  emits: ['update:modelValue', 'change','blur', 'keydown', 'keyup'],
  name: 'CustomBirthdayInput',
   props: {
    profileStyle:{
      type: Boolean,
      required: false,
      default: false
    },
    id: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: true,
    },
    modelValue:{
      type: String,
    },    
    form:{
      type: Object,
      required: false
    },
    errors:null,
    paramName:{
      type: String,
      required: true
    },
    dateFormat:{
      type: String,
      required: true
    }
  },
  data: () => ({
    day: '',
    month: '',
    year: '',
    dayLength: 0,
    monthLength: 0,
    yearLength: 0,
    order: [],
    inputDay: '',
    inputMonth: '',
    inputYear: '',
    separator: '',
  }),
  watch: {
    "modelValue": {
      deep: true,
      handler(newVal, oldVal) {
        if(this.oneMoment && this.oneMoment.isValidDate(newVal, this.dateFormat)){
          this.setValue();
        }
      },
    },
  },
  computed: {
    error(){
      return this.errors.find(e=>e.thereIsTheError);
    },
    invalid(){
      return this.error && this.form[this.paramName].$dirty
    },
    validAndDirty(){
      return this.form[this.paramName].$dirty && !this.invalid;
    }
  },
  async mounted() {
    const awaitImport = await import('../../../gcdm-one-library/gcdm-one-moment/src/bootstrap');
    this.oneMoment = (awaitImport).default;
    this.separator = this.getSeparator();
    this.setFormatValue();
    if (this.modelValue && this.modelValue !== this.dateFormat) {
      this.setValue();
    }
  },
  methods: {
    getInputClass(index) {
      if (index === 2) {
        return 'lastElement';
      } else {
        return 'firstElement';
      }
    },
    getSeparator() {
      let d = this.dateFormat;
      d = d.replaceAll('M', '');
      d = d.replaceAll('D', '');
      d = d.replaceAll('Y', '');
      return d.charAt(0);
    },
    getInputValue(o) {
      switch(o) {
        case 'D':
            return this.inputDay ? this.inputDay : '';
        case 'M':
            return this.inputMonth ? this.inputMonth : '';
        case 'Y':
            return this.inputYear ? this.inputYear : '';
        default:
            return ''; 
      }
    },
    setValue() {
      let sep = this.modelValue.replace(/[0-9]/g, '');
      sep = sep.charAt(0);
      const V = this.modelValue.split(sep);
      this.order.forEach((value, index) => {
        switch(value) {
          case 'D':
              this.inputDay = V[index];
            break;
          case 'M':
              this.inputMonth = V[index];
            break;
          case 'Y':
              this.inputYear = V[index];
            break;
          default:
            break;
        }
      });
    },
    getPlaceholder(o) {
      switch(o) {
        case 'D':
            return this.day;
        case 'M':
            return this.month;
        case 'Y':
            return this.year;
        default:
            return ''; 
      }
    },
    setFormatValue() {
      this.day = this.dayValue();
      this.month = this.mouthValue();
      this.year = this.yearValue();
      this.orderValue();
    },
    orderValue() {
        //this.dateFormat = 'MM/DD/YYYY'
        let splittedFormatDate = this.dateFormat;
        splittedFormatDate = splittedFormatDate.split(this.separator);
        const positionValue = splittedFormatDate[0].charAt(0) + splittedFormatDate[1].charAt(0) + splittedFormatDate[2].charAt(0);
        this.order.push(positionValue.charAt(0));
        this.order.push(positionValue.charAt(1));
        this.order.push(positionValue.charAt(2));
    },
    dayValue() {
      let d = this.dateFormat;
      d = d.replaceAll('M', '');
      d = d.replaceAll(this.separator, '');
      d = d.replaceAll('Y', '');
      this.dayLength = d.length;
      return d;
    },
    mouthValue() {
      let m = this.dateFormat;
      m = m.replaceAll('D', '');
      m = m.replaceAll(this.separator, '');
      m = m.replaceAll('Y', '');
      this.monthLength = m.length;
      return m;
    },
    yearValue() {
      let y = this.dateFormat;
      y = y.replaceAll('D', '');
      y = y.replaceAll('M', '');
      y = y.replaceAll(this.separator, '');
      this.yearLength = y.length;
      return y;
    },
    validateValue(event) {
      if (event.target.id.includes('_D')) {
              this.dayValidating(event);
      } else if (event.target.id.includes('_M')) {
              this.monthValidating(event);
      } else if(event.target.id.includes('_Y')) {
              this.yearValidating(event);
      }
    },
    setInputValue(event) {
      if (event.target.id.includes('_D')) {
            this.inputDay = event.target.value;
      } else if (event.target.id.includes('_M')) {
            this.inputMonth = event.target.value;
      } else if(event.target.id.includes('_Y')) {
                this.inputYear = event.target.value;
      }
    },
    nextElement(element) {
      let index = 0;
      let next = '';
      for (const o of this.order) {
        index += 1;
        if (o === element) {
          if (index < 3) {
            next = this.order[index];
          }
          break;
        }
      }
      if (next) {
          document.getElementById(this.id + '_' + next).focus();
      } 
    },
    beforeElement(element) {
      let j = 0;
      let before = '';
        for (const o of this.order) {
          j += 1;
          if (o === element) {
              if (j > 0) {
                before = this.order[j - 2];
              }
            break;
          }
        }
        if (before) {
          const el = document.getElementById(this.id + '_' + before);
          const len = el.value.length;
              
          // Mostly for Web Browsers
          if (el.setSelectionRange) {
              el.focus();
              setTimeout(() => {
                el.setSelectionRange(len, len);
              }, 100);
          } else if (el.createTextRange) {
              const t = el.createTextRange();
              t.collapse(true);
              t.moveEnd('character', len);
              // t.moveStart('character', len);
              t.select();
          }
        }
    },
    dayValidating(event){
      if(event.target.value.length == this.dayLength) {
        // writing... ->
        // const valid = this.checkDate(event.target.value, this.dayValue());
        if (Number(event.target.value)<=31) {
                this.nextElement('D');
        } 
      } else {
        //deleting..  <-
        if (event.target.value.length < 1) {
          this.beforeElement('D');
        }
      }
    },
    checkDate(dateString, format) {
      const valid = this.oneMoment.isValidDate(dateString, format);
      return valid;
    },
    monthValidating(event) {
      if(this.inputMonth.length < event.target.value.length) {
        // writing... ->
        const valid = this.checkDate(event.target.value, this.mouthValue());
        if (valid) {
                // ->
                this.nextElement('M');
        } 
      } else {
        //deleting..  <-
        if (event.target.value.length < 1) {
          this.beforeElement('M');
        }
      }
    },
    yearValidating(event) {
      if(this.inputYear.length < event.target.value.length) {
          // writing... ->
        const valid = this.checkDate(event.target.value, this.yearValue());
        if (valid) {
                // ->
                this.nextElement('Y');
          } 
      } else {
        //deleting..  <-
        if (event.target.value.length < 1) {
          this.beforeElement('Y');
        }
      }
    },
    getDateToEmit(){
      let toReturn = '';
      for (const o of this.order) {
        switch(o) {
          case 'D':
              toReturn += this.inputDay+this.separator;
              break;
          case 'M':
              toReturn += this.inputMonth+this.separator;
              break;
          case 'Y':
              toReturn += this.inputYear+this.separator;
              break;
          default:
              return '';
        }
      }
      if(toReturn==this.separator+this.separator+this.separator) return '';
      return toReturn.substring(0,toReturn.length-1);
    },
    onInput(event) {
      // Can add validation here
      this.validateValue(event);
      this.setInputValue(event)
      this.$emit('update:modelValue', this.getDateToEmit());
    },
    onChange(event) {
      this.setInputValue(event)
      this.$emit('change',  this.getDateToEmit());
    },
    onBlur(event) {
      this.setInputValue(event)
      this.$emit('blur',  this.getDateToEmit());
    },
    onKeydown(event) {
      this.setInputValue(event);
      this.$emit('keydown',  this.getDateToEmit());
    },
    onKeyup(event) {
      if (event.key === 'Backspace' && event.target.value === "") {
          this.validateValue(event);
      }
      this.setInputValue(event)
      this.$emit('keyup',  this.getDateToEmit());
    },
  },
}

</script>


<style lang="scss" scoped>
  .custom-date-input{
    &.firstElement {
        border-top: none;
        border-left: none;
        border-bottom: none;
        border-right: 1px solid #BBBBBB;
        outline:none;
        padding-left:11px;
        background: transparent;
        margin-top:0px;
        font-size: 16px;
        font-family: inherit;
    }
    &.lastElement {
        border:none;
        outline:none;
        padding-left:11px;
        background: transparent;
        margin-top:0px;
        font-size: 16px;
        font-family: inherit;
    }
    &.D {
        width: 52px;
    }
    &.M {
        width: 52px;
    }
    &.Y {
        width: 80px;
    }
  }


  .custom-label{
    font-size: 14px;
    position: relative;
    display: inline-block;
    padding: 14px;
    margin: -14px;
    &.__m{
      color: black;
      font-family: MINISansSerif;
    }
    &._profileStyle{
      font-size: 12px;
      font-weight: bold;
      color: $grey5;
      margin-bottom: -6px;
      &.__m{
        color: black;
      }
      &.__t{
        color: black;
      }
    }
    &.__t{
      font-family: ToyotaSemibold;
    }
  }
  .custom-birthday-field{
    font-family: inherit;
    border: 1px solid $grey;
    width: 100%;
    line-height: 1em;
    padding: 11px 45px 8px 11px;
    min-width: 0;
    color: $black;
    font-size: 16px;
    height: 48px;
    &:focus {
      outline: none;
      border: 2px solid black;
    }
    &.__b {
      border: 2px solid $grey13;
    }
    &.__m {
      border: 1px solid black;
      font-family: MINISansSerif;
      color: black;
      font-weight: 300; 
      font-size: 18px;
      &:focus {
        outline: none;
        border: 2px solid black;
      }
    }
    &.__motorrad {
      border: 1px solid $motorradDarkGrey;
    }
    &.__t{
      color: black;
      font-family: ToyotaSemibold;
      border: 1px solid $toyotainputborder;
      font-size: 15px;
      &:focus {
        outline: none;
        border: 2px solid black;
      }
    }
    &.__d{
      box-shadow: 0 0 0 30px transparent !important;
      -webkit-box-shadow: 0 0 0 30px transparent !important;
      -webkit-text-fill-color: #fff!important;
      background: transparent;
      color: white !important;
      border: 1px solid white;
      &:focus {
        outline: none;
        border: 2px solid white;
      }
    }
    &:disabled{
      background-color: $grey6;
      &.__d{
        background-color: transparent;
      }
    }
    &._profileStyle{
      height: 52px;
    }
    &.__rr {
      background-color: white;
      font-family: RivieraNights-Light;
    }
  }
  
  .custom-birthday--invalid{
    .custom-error{
      color: $red;
      font-size: 12px;
      line-height: 14px;
      margin-top: 5px;
      
      &.__d{
        color: $darkmodeRed;
      }
    }
    .custom-label{
      &.__m{
        color: $grey5;
      }
      &.__t{
        color: $toyotared;
      }
      &.__d{
        color:#eb4747;
      }
    }
    .custom-birthday-field{
      background: $errorbg;
      border: 2px solid $errorred;
      &:focus {
        outline: none;
        border: 2px solid black;
      }
      &.__t{
        font-family: Arial, Helvetica, sans-serif;
        input{
          color: $toyotared;
        }
        border: 2px solid $toyotared;
        &:focus {
          outline: none;
          border: 2px solid black;
        }
      }
      &.__m{
        &__d{
          background: transparent;
          border: 2px solid $darkmodeRed;
          color: white;
        }
      }
      &.__d{
        background: transparent;
        border: 2px solid $darkmodeRed;
        color: white;
        &:focus {
          outline: none;
          border: 2px solid white;
        }
      }
    }
  }


</style>